// extracted by mini-css-extract-plugin
export default {"main_info":"styles_main_info__Pyv5j","name":"styles_name__-+FvB","divider":"styles_divider__Ey9nd"};